module.exports = __webpack_public_path__ + "32fc3a2c.png";